// Length caps for Person free-text, shared by the web form (maxLength) and the
// API write guard. Notes shares the item with other encrypted fields, so the cap
// is on the TOTAL stored value, not a per-write append.
export const PERSON_NOTES_MAX_LENGTH = 10_000;
export const PERSON_TEXT_FIELD_MAX_LENGTH = 500;

export const EVENT_TITLE_MAX_LENGTH = 200;
export const EVENT_DESCRIPTION_MAX_LENGTH = 500;

// The single "is this the raw personId form?" predicate, shared by the web (what
// to emit into the URL) and isRawPersonId on the API (how to resolve one). Two
// copies drifting is a broken link in production, with no build error.
export const PERSON_ID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
